import { CAPABILITIES } from "../../data/content";
import { Reveal } from "../Reveal";

export default function Capabilities() {
  return (
    <section id="capabilities" className="relative bg-navy-800 py-24 sm:py-32 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-12">
        <Reveal>
          <p className="mb-4 text-[11px] uppercase tracking-[0.4em] text-gold">What we do</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-3xl font-heading text-4xl font-light leading-tight text-offwhite sm:text-5xl">
            Four disciplines, one accountable team.
          </h2>
        </Reveal>

        <div className="mt-16 border-t border-gold/10">
          {CAPABILITIES.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.04}>
              <div
                data-testid={`capability-${i}`}
                data-cursor="hover"
                className="group relative flex cursor-pointer flex-col gap-3 border-b border-gold/10 py-8 transition-all duration-500 hover:pl-4 md:flex-row md:items-center md:justify-between md:gap-6 md:py-10"
              >
                <div className="flex items-baseline gap-5 sm:gap-8">
                  <span className="text-xs text-gold/60">{c.no}</span>
                  <h3 className="font-heading text-2xl font-light text-offwhite transition-colors duration-500 group-hover:text-gold sm:text-4xl">
                    {c.title}
                  </h3>
                </div>
                <p className="max-w-md pl-9 text-sm font-light text-offwhite/50 md:pl-0 md:text-right">
                  {c.detail}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
